import {connect} from "react-redux";
import CarServiceActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {getActivity, activitySave, isCheckout, getPendingActivity, markAttendance, lastCheckIn} from "../../../../service/CarService/action";
import {getSenior} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    types:state.CarService.types,
    saveActivityResponse:state.CarService.saveActivityResponse,
    isCheckoutDetails:state.CarService.isCheckout,
    pendingActivity:state.CarService.pendingActivity,
    attendance:state.CarService.attendance,
    senior: state.Dealer.senior,
    lastCheckInRes:state.CarService.lastCheckInRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getActivity,
            getSenior,
            activitySave,
            isCheckout,
            getPendingActivity,
            markAttendance,
            lastCheckIn,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceActivitySave);
